import(/* webpackMode: "eager", webpackExports: ["ShopSkeleton"] */ "/opt/buildhome/repo/components/ui/Skeletons.tsx");
